import { ResponsivePie } from "@nivo/pie";
import React from "react";

export const PieChartGeneral = ({ pieChartProps = { data: [] }, className = "" }) => {
	const commonProperties = {
		margin: { top: 80, right: 120, bottom: 80, left: 120 },
		animate: true,
		innerRadius: 0,
		colors: (parent, child) => {
			if (parent.data.color) {
				return parent.data.color;
			}
			return "#ccc";
		},
		enableArcLabels: false,
		arcLinkLabel: (d) => `${d.id} (${d.value})`,
	};
	return (
		<div className={className}>
			<ResponsivePie {...commonProperties} {...pieChartProps} />
		</div>
	);
};
